// Sécurité par appareil : identifiant STABLE de l'appareil, mémorisé en localStorage (persiste à la
// fermeture d'onglet, contrairement à sessionStorage). Généré côté client à la 1ʳᵉ utilisation et
// renvoyé au backend à chaque connexion. Un appareil inconnu du backend déclenche un challenge OTP.
//
// Note sécurité : le deviceId n'est PAS un secret — la protection vient du challenge OTP sur appareil
// non reconnu (+ alerte e-mail), pas de la confidentialité de l'id.

const DEVICE_KEY = "poolins_device_id";

function generateUuid() {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }
  } catch (_) { /* ignore */ }
  // Repli si crypto.randomUUID indisponible.
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// Renvoie le deviceId existant, ou en crée un et le persiste.
export function getOrCreateDeviceId() {
  try {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) {
      id = generateUuid();
      localStorage.setItem(DEVICE_KEY, id);
    }
    return id;
  } catch (_) {
    // localStorage indisponible (navigation privée stricte…) → id éphémère (challenge à chaque fois).
    return generateUuid();
  }
}

export function getDeviceId() {
  try {
    return localStorage.getItem(DEVICE_KEY) || null;
  } catch (_) {
    return null;
  }
}
